export var TranslationKey;
(function (TranslationKey) {
    TranslationKey["FORM_FIELD_LABEL_OPTIONAL"] = "vel_form_field_label_optional";
    TranslationKey["DATE_PICKER_INVALID_INPUT_VALUE"] = "vel_date_picker_invalid_input_value";
})(TranslationKey || (TranslationKey = {}));
//# sourceMappingURL=TranslationKey.js.map